/**
 * Created by Bart Decorte
 * Date: 05/01/2021
 * Time: 16:53
 */
import Page from '../../pages/Page';
import Request from '../../utils/Request';

export default class ConnectionCheckIndex extends Page {
  constructor() {
    super();
    this.root = document.querySelector('.js-websites');
    this.pendingRequests = 0;
    this.maxSimultaneousRequests = 10;
    this.queue = this.getQueue();
    this.check();
  }

  getQueue() {
    return [...this.root.querySelectorAll('.js-website')].map(
      (el) => el.dataset.websiteId
    );
  }

  check() {
    for (let i = 0; i < this.maxSimultaneousRequests; i++) {
      this.checkNext();
    }
  }

  checkNext() {
    if (!this.queue.length) {
      return;
    }

    if (this.pendingRequests >= this.maxSimultaneousRequests) {
      return;
    }

    const id = this.queue.shift();
    new Request(`websites/${id}/test-database-connection`, 'GET')
      .execute()
      .then(({ data: { succeeds, reason } }) => {
        this.setState(id, succeeds ? 'connection-success' : 'connection-error');
        if (!succeeds) {
          this.setReason(id, reason);
        }
      })
      .catch(() => {
        this.setState(id, 'fail');
        return true;
      })
      .then(() => {
        this.pendingRequests--;
        this.checkNext();
      });
  }

  entryEl(id) {
    return this.root.querySelector(`.js-website[data-website-id="${id}"]`);
  }

  setState(entryId, state) {
    const stateEls = [...this.entryEl(entryId).querySelectorAll('.js-state')];
    stateEls.forEach((stateEl) => {
      if (!stateEl.classList.contains('d-none')) {
        stateEl.classList.add('d-none');
      }
      if (stateEl.classList.contains('d-flex')) {
        stateEl.classList.remove('d-flex');
      }
    });
    const stateEl = this.entryEl(entryId).querySelector(`.js-state--${state}`);
    stateEl.classList.remove('d-none');
    if (stateEl.tagName !== 'SPAN') {
      stateEl.classList.add('d-flex');
    }
  }

  setReason(entryId, reason) {
    const reasonEl = this.entryEl(entryId).querySelector('.js-reason');
    reasonEl.setAttribute('title', reason);
    reasonEl.dataset.originalTitle = reason;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/tools/connection-check/ConnectionCheckIndex.js